const GlobalScrollbarStyle = ({ theme }) => {
  return (
    <style jsx global>{`
      * {
        scrollbar-width: thin;
        scrollbar-color: ${theme.styles.menu.button.shadowColor} #000000;
      }

      *::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      *::-webkit-scrollbar-track {
        background: transparent;
      }

      *::-webkit-scrollbar-thumb {
        background-color: ${theme.styles.menu.button.shadowColor};
        border-radius: 4px;
        border: 2px solid transparent;
      }

      *::-webkit-scrollbar-thumb:hover {
        background-color: ${theme.styles.menu.button.shadowColor};
        opacity: 0.8;
      }
    `}</style>
  );
};

export default GlobalScrollbarStyle;